import { createRoot } from 'react-dom/client'
import './styles.css'
import { Logo } from '@pmndrs/branding'
import { App } from './App'

/*
Model JSX auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.3 model.glb --transform --simplify --resolution=2048
Author: Omar Faruq Tawsif (https://sketchfab.com/omarfaruqtawsif32)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
*/

function Root() {
  return (
    <>
      <App />
      <div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: 0, width: '100vw', height: '100vh' }}>
        <div style={{ position: 'absolute', bottom: 30, left: 30, fontSize: '13px' }}>
          scroll up/down ...
        </div>
        {/* <a href="https://madovertech.io/" style={{ position: 'absolute', bottom: 30, left: 90, fontSize: '13px' }}>
          madovertech.io
          <br />
          New Media Technology
        </a> */}
        <div style={{ position: 'absolute', bottom: 30, right: 30, fontSize: '13px', display: "flex", flexDirection: "column", alignItems: "flex-end"}}>
          <div href="tel:+919711699861">+91-9711699861</div>
          <div href="mailto:hello@madovertech.io">hello@madovertech.io</div>
        </div>
        {/* <Logo style={{ position: 'absolute', bottom: 30, left: 30, width: 30 }} /> */}
        <div style={{ position: 'absolute', top: 30, left: 30, fontSize: '13px', cursor:"" }}>
          <b>Interactive Tech Solutions</b>
          <br/>
          for Events & Exhibitions
        </div>
        <a style={{ position: 'absolute', top: 30, right: 30, fontSize: '13px' }} href="https://calendly.com/hi-mot/15min" target="_blank">
          {"Let's Tech ->"}
        </a>
      </div>{' '}
    </>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
